module.exports = __webpack_public_path__ + "img/shopping_application_2-1.293f1e6a.jpg";